module.exports = __webpack_public_path__ + "media/virtualStaging/galleryImage1-1-305c401f.png";